import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertaDto } from '../../../dto/alerta/alerta.dto';
import { AlertaService } from '../../../services/alerta.service';
import { NavigationEnd, Router } from '@angular/router';
import { AlertaFiltroDto } from '../../../dto/alerta/alerta.filtro.dto';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { Constants } from '../../../constants/constants';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-visualizar-alertas-tramites',
  templateUrl: './visualizar-alertas-tramites.component.html',
  styleUrl: './visualizar-alertas-tramites.component.scss',
})
export class VisualizarAlertasTramitesComponent implements OnInit, OnDestroy {

  readonly ALERTA_CREACION_TRAMITE_EXITOSO = 3;
  readonly ALERTA_CREACION_TRAMITE_FALLIDO = 6;

  alertas: AlertaDto[] = [];
  pagina = 1;
  totalPaginas = 0;
  countAlertas = 0;
  private userData: UserDataDto = {};
  private destroy$ = new Subject<void>();
  constructor(
    private alertaService: AlertaService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );

    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.pagina = 1;
          this.userData = JSON.parse(
            sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
          );
          if (this.userData?.idUsuario) {
            this.filtrarAlertas();
          }
        }
      });

    if (this.userData?.idUsuario) {
      this.filtrarAlertas();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  filtrarAlertas() {
    const filtros: AlertaFiltroDto = {
      tiposAlerta: [this.ALERTA_CREACION_TRAMITE_EXITOSO,this.ALERTA_CREACION_TRAMITE_FALLIDO],
      usuario: this.userData.idUsuario,
    };
    this.alertaService
      .filtrar({
        tamanoPagina: 10,
        pagina: this.pagina,
        filtros: filtros,
      }).pipe(takeUntil(this.destroy$))
      .subscribe(alertas => {
        this.totalPaginas = alertas.totalPaginas;
        if (this.pagina > 1) {
          this.alertas = this.alertas.concat(alertas.registros);
        } else {
          this.alertas = alertas.registros;
        }
        this.pagina += 1;
      });
    this.alertaService
      .contarPorFiltro({
        leido: false,
        tiposAlerta: [this.ALERTA_CREACION_TRAMITE_EXITOSO,this.ALERTA_CREACION_TRAMITE_FALLIDO],
        usuario: this.userData.idUsuario,
      }).pipe(takeUntil(this.destroy$))
      .subscribe(cantidad => {
        this.countAlertas = cantidad;
      });
  }
}
